import 'core-js/modules/es.regexp.exec.js';
import 'core-js/modules/es.string.replace.js';
import { __decorate, __param, __metadata, __awaiter } from '../../_virtual/_tslib.js';
import { AssetType } from '@hub-la/fe-asset';
import { HttpClient, HttpMethod, HttpStatusCode } from '@hub-la/fe-core-http-client';
import { saveAs } from 'file-saver';
import { inject } from 'inversify';
import { Envs } from '../envs.js';

let SaveFile = class SaveFile {
  constructor(httpClient) {
    this.httpClient = httpClient;
  }
  execute(asset) {
    return __awaiter(this, void 0, void 0, function* () {
      if (asset.url) {
        if (asset.type === AssetType.video) {
          const videoDownloadUrl = this.getVideoDownloadUrl(asset);
          saveAs(videoDownloadUrl, asset.name);
          return;
        }
        yield this.downloadAssetFromStorage(asset);
      }
    });
  }
  getVideoDownloadUrl(asset) {
    const removeFileExtension = (fileName = '') => fileName.replace(/\.[^/.]+$/, '');
    const muxStreamUrl = Envs.MUX_STREAM_URL;
    const assetId = removeFileExtension(asset.url).replace(`${muxStreamUrl}/`, '');
    const assetDownloadName = removeFileExtension(asset.name);
    const videoUrlDownload = `${muxStreamUrl}/${assetId}/low.mp4?download=${assetDownloadName}`;
    return videoUrlDownload;
  }
  downloadAssetFromStorage(asset) {
    return __awaiter(this, void 0, void 0, function* () {
      if (asset.url) {
        const response = yield this.httpClient.request({
          url: asset.url,
          method: HttpMethod.GET,
          responseType: 'arraybuffer'
        });
        if (response.statusCode === HttpStatusCode.OK) {
          this.makeOutput(asset, response.data);
          return;
        }
        throw new Error();
      }
    });
  }
  makeOutput(asset, value) {
    const fileType = `${asset.type}/${asset.subType}`;
    const file = new Blob([value], {
      type: fileType
    });
    saveAs(file, asset.name);
  }
};
SaveFile = __decorate([__param(0, inject(HttpClient)), __metadata("design:paramtypes", [HttpClient])], SaveFile);

export { SaveFile };
